import { useQuery } from '@apollo/client/react';
import { Box, Pagination } from 'components/ui';
import { useError } from 'contexts/error';
import { usePaginate } from 'contexts/paginate';
import {
  CardOptionDescriptionTypography,
  CardOptionHintTypography,
  CardOptionTypography,
} from 'components/styles_components/typography';
import SessionInfosQuery from 'queries/session_info/index';
import Index from 'components/session_info/index';
import DeleteAllButton from 'components/session_info/button/delete_all';
import LoaderContainer from 'components/layout/loader_container';
import { FormattedMessage } from 'react-intl';
import { WhiteCard } from 'components/styles_components/card';

const IndexContainer = () => {
  const { page, onPageChange } = usePaginate();
  const setError = useError();
  const {
    data = { sessionInfos: { sessionInfos: [], perPage: 10 } },
    loading,
    error,
    refetch,
  } = useQuery(SessionInfosQuery, {
    variables: { page },
    onError: () => {
      setError('error.session_info.index');
    },
  });

  const onRemove = () => {
    if (page > 1) {
      onPageChange(page - 1);
    } else {
      refetch();
    }
  };

  const sessions = data.sessionInfos.sessionInfos;
  const sessionsCount = data.sessionInfos.sessionInfosTotal ?? sessions.length;
  const devicesCount = new Set(sessions.map((s) => `${s.platform}|${s.os}`)).size;

  return (
    <LoaderContainer loading={loading} error={error} wrap={false}>
      <WhiteCard>
        <CardOptionTypography>
          <FormattedMessage id="user.session.title" />
        </CardOptionTypography>

        <Box display="flex" justifyContent="space-between" alignItems="center">
          <CardOptionDescriptionTypography>
            <FormattedMessage id="session_info.summary" values={{ sessionsCount, devicesCount }} />
          </CardOptionDescriptionTypography>
          <DeleteAllButton />
        </Box>
      </WhiteCard>

      <Index sessionInfos={data.sessionInfos.sessionInfos} onRemove={onRemove} />
      <Box display="flex" justifyContent="center">
        {data.sessionInfos.sessionInfosTotalPages > 1 && (
          <Pagination
            count={data.sessionInfos.sessionInfosTotalPages}
            page={page}
            onChange={(_e, nextPage) => {
              onPageChange(nextPage);
            }}
          />
        )}
      </Box>
    </LoaderContainer>
  );
};

export default IndexContainer;
